// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"3d7ed4d9","25":"f3c99d34","246":"61f36386","360":"ee6fb299","385":"798b8599","453":"8245e833"}[chunkId] + ".chunk.js";
};